import React from "react";
import { genURL, INSCorServicePostTest } from '../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PopUpOther5 from './PopUpARPaybillsub';
import axios from 'axios'

require('../_css/PopUpARInvDebt.css');

export default class PopUpOther extends React.Component {
    constructor(props) {
        super(props);
        this.P_DOCNO = React.createRef();
        this.Search = React.createRef();
        this.state = {
            showPopupOT5: false,
            type: this.props.type,
            col: [],
            rows: [],
            Htext: "",
            SHtype: 3,
            casschkbox: "far fa-square",
            casschkboxs: false,
            ckbox_length: 0,
        }
    }

    chkdata = (data) => {
        var redata = "";
        if (data !== null && data !== undefined) {
            redata = data;
        }
        return redata;
    }
    //--------------------------------โชว์ PopUpARPaybillsub
    SetPopup3 = (data) => {
        this.setState({ PopUpTYpe5: data });
        this.setState({ showPopupOT5: !this.state.showPopupOT5 });
    }

    //รับค่าหน้า PopUpARPaybillsub แล้วส่งค่ากลับหน้าหลัก
    Get_PopUpOther5 = (data) => {
        for (var i = 0; i < data.length; i++) {
            var redata =
                this.chkdata(data[i].DOCNO) + "|" +
                this.chkdata(data[i].REFTAXNO) + "|" +
                this.chkdata(data[i].DOCDATE) + "|" +
                this.chkdata(data[i].CREDITCODE) + "|" +
                this.chkdata(data[i].REFDUEDATE) + "|" +
                this.chkdata(data[i].TRANSNAME) + "|" +
                this.chkdata(data[i].department) + "|" +
                this.chkdata(data[i].PAYAMOUNT) + "|" +
                this.chkdata(data[i].PAYAMOUNT) + "|" +
                this.chkdata(data[i].REMARK) + "|" +
                this.chkdata(data[i].TYPE) + "|" +
                this.chkdata(data[i].DOCNO) + "|" +
                this.chkdata(data[i].REFDOCTYPE)
                this.props.Get_PopUpOther4(redata);
        }
        this.setState({ showPopupOT5: !this.state.showPopupOT5 });
    }
    PopUpOtherClose5 = (data) => {
        this.setState({ showPopupOT5: !this.state.showPopupOT5 });
    }
    //--------------------------

    //กดค้นหา
    Get_Data = (event) => {
        var dataArray = [];
        var Url = "";
        var DOCNO = ""
        if (event === "ARPaybill") {
            DOCNO = this.Search.current.value;
            Url = "CSARPAYBILL/Searchpaybill?ARCODE=" + this.props.ARCODE + "&DOCNO=" + DOCNO
            // Url = "http://Localhost:8080/Searchpaybill?ARCODE=" + this.props.ARCODE +"&DOCNO=" + DOCNO
        } else if (event.key === "Enter") {
            DOCNO = (event.target.value);
            Url = "CSARPAYBILL/Searchpaybill?ARCODE=" + this.props.ARCODE + "&DOCNO=" + DOCNO
            // Url = "http://Localhost:8080/Searchpaybill?ARCODE=" + this.props.ARCODE +"&DOCNO=" + DOCNO
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
        // GetCorServicei(Url, "iconsearch").then(res => {
        axios.get(genURL(Url)).then(res => {
            console.log("CSARPAYBILL", res)
            if (res.data.length >= 1) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[i] = {
                        number: i + 1,
                        DOCNO: res.data[i].DOCNO,
                        DOCDATE: this.GetformatTimestamp(res.data[i].DOCDATE),
                        PAYDATE: this.GetformatTimestamp(res.data[i].PAYDATE),
                        SUMPAYAMOUNT: res.data[i].SUMPAYAMOUNT,
                        REMARK: res.data[i].REMARK, 
                        SELFLAG: res.data[i].SELFLAG,
                        SB: "0"

                    }
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
    }

    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    componentDidMount() {
        //โหลดหน้าครั้งแรกเรียก API โชว์ข้อมูล
        var dataArray = [];
        switch (this.props.type) {
            case "ARPaybill":
                this.setState({ sh_Deposit: true });
                // var Url = "http://Localhost:8080/Searchpaybill?ARCODE=" + this.props.ARCODE 
                // INSCorServicePostTest(Url,"").then(res => { 
                var Url = "CSARPAYBILL/Searchpaybill?ARCODE=" + this.props.ARCODE
                axios.get(genURL(Url)).then(res => {
                    console.log("CSARPAYBILL", res)
                    if (res.data.length >= 1) {
                        for (let i = 0; i < res.data.length; i++) {
                            dataArray[i] = {
                                number: i + 1,
                                DOCNO: res.data[i].DOCNO,
                                DOCDATE: this.GetformatTimestamp(res.data[i].DOCDATE),
                                PAYDATE: this.GetformatTimestamp(res.data[i].PAYDATE),
                                SUMPAYAMOUNT: res.data[i].SUMPAYAMOUNT,
                                REMARK: res.data[i].REMARK,
                                SELFLAG: res.data[i].SELFLAG,
                                SB: "0"
                            }
                        }
                        this.setState({ col: dataArray });
                        this.GetSearchTimeout();
                    } else {
                        dataArray = [];
                        this.setState({ col: dataArray });
                        this.GetSearchTimeout();
                    }
                });

                this.setState({ col: dataArray, Htext: "เลือกใบวางบิล" });
                break;
            default: break;
        }
    }

    //onClick checkbox 
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i class="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i class="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i class="">  </i></span>;

        }
        return (<div>{btnShow}</div>)
    }

    //เปลี่ยนสถานะ checkbox 
    Update_Status = (Row, Status) => {
        if (Status === "ALL") {

            if (this.state.casschkboxs === false) {
                //กด checkbox เลือกทั้งหมด
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });

                let dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });

            } else {
                //กด checkbox ไม่เลือก
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });

                let dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }

        } else {
            //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }

            //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
            var dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });


            //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }

    onSelectRow = (data, col, id) => {
        //ส่งกลับเมื่อมีการคลิกเลือกข้อมูล
        if (col > 1) {
            var docno = "";
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            // var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === "1") {
                    // sb_length = sb_length + 1;
                    docno = docno +   this.state.rows[i].DOCNO+"|"
                }
            }
            console.log(docno);
            this.P_DOCNO.current.value = docno
            setTimeout(() => {
                this.setState({ PopUpTYpe5: data });
                this.setState({ showPopupOT5: !this.state.showPopupOT5 });
            }, 500);
        }
    }
    onSubmit = () => {
        //ส่งกลับเมื่อมีการคลิกเลือกข้อมูล
        var docno = "";
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
            if (this.state.rows[i].SB === "1") {
                // sb_length = sb_length + 1;
                docno = docno +   this.state.rows[i].DOCNO+"|"
            }
        }
        console.log(docno);
        this.P_DOCNO.current.value = docno
        setTimeout(() => {
            // this.setState({ PopUpTYpe5: data });
            this.setState({ showPopupOT5: !this.state.showPopupOT5 });
        }, 500);
    }

    render() {
        return (
            <div className='popup' style={{ 'z-index': '100' }} >
                {this.state.showPopupOT5 ? <PopUpOther5 closePopup={this.PopUpOtherClose5} Get_PopUpOther5={this.Get_PopUpOther5} type={this.state.PopUpTYpe5} Data={this.state.valuePopup5} ARCODE={this.props.ARCODE} P_DOCNO={this.P_DOCNO.current.value} from="PopUpARPaybill"/> : null}
                <div className='popup_inner'>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-at" > {this.state.Htext} </i></div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div class="panel-body divTable" align="right" >
                        <div class="form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6"  >
                            <input type="hidden" class="form-control " ref={this.P_DOCNO} />
                            <input id="id1" type="text" class="form-control" ref={this.Search} onKeyPress={this.Get_Data.bind(null)} onBlur={this.Get_Data.bind(null, "ARPaybill")} />
                            <span id="iconsearch" class="input-group-addon icon" ><i class="fas fa-search"></i></span>
                        </div>
                        <div style={{ marginTop: "10px" }}>
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="580"
                                hover condensed 
                                 >
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="4%" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="5%" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i style={{ fontSize: '20px' }} class={this.state.casschkbox}> </i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='DOCNO' > เลขที่วางบิล </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="16%" dataField='DOCDATE' > วันที่วางบิล </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="16%" dataField='PAYDATE' > วันนัดชำระ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="16%" dataField='SUMPAYAMOUNT' > ยอดวางบิล </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="27%" dataField='REMARK' > หมายเหตุ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="27%" dataField='SELFLAG' > SELFLAG </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        <button class="PUSDbtn" onClick={this.onSubmit}>
                            <i class="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}